import { Link } from 'react-router-dom'
import tools from '../tools/registry'
import './Dashboard.css'

export function Dashboard() {
  return (
    <div className="dashboard">
      <div className="dashboard-bg" />

      <main className="dashboard-main">
        <div className="dashboard-header">
          <div>
            <h1>IntelliJet Tools</h1>
            <p>{tools.length} tool{tools.length !== 1 ? 's' : ''} available</p>
          </div>
        </div>

        <div className="tools-grid">
          {tools.map((tool) => (
            <Link key={tool.slug} to={`/tool/${tool.slug}`} className="tool-card">
              <div className="tool-card-icon">{tool.icon}</div>
              <div className="tool-card-body">
                <h3>{tool.name}</h3>
                <p>{tool.description}</p>
              </div>
              <div className="tool-card-footer">
                <span className="tool-card-cta">
                  Open tool
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  )
}
